import { ReactElement, Suspense } from "react";

import { Redirect, Switch, Route } from "_/components/router";
import { TabForRoute, TabBar } from "_/components/tab-bar";
import { PermissionTest } from "_/components/permission-test";
import { Skeleton } from "_/components/skeleton";

import { ROOT_DOMAIN } from "_/data/rbac";

import { JobsView } from "./jobs";
import { OrgDetailView, OrgsView } from "./orgs";

import * as S from "./styled";

const PageSkeleton = () => (
  <S.TabPage>
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </S.TabPage>
);

export const InternalView = (): ReactElement => {
  const tabs = [
    {
      name: "Jobs",
      route: "/internal/jobs",
      url: "/internal/jobs",
      component: JobsView,
    },
    {
      name: "Orgs",
      route: "/internal/orgs",
      url: "/internal/orgs",
      component: OrgsView,
    },
  ];

  const tabItems = tabs.map((t) => (
    <TabForRoute key={t.route} route={t.route} url={t.url}>
      {t.name}
    </TabForRoute>
  ));

  const routes = tabs.map((tab) => {
    const Component = tab.component;
    return (
      <Route key={tab.route} path={tab.route}>
        <Suspense fallback={<PageSkeleton />}>
          <Component />
        </Suspense>
      </Route>
    );
  });

  const forbiddenError = (
    <S.ForbiddenError>
      <div>
        <h1>Access Denied</h1>
        <p>You do not have permission to view this page.</p>
        <p>If you believe this to be in error, please contact AON3D support.</p>
      </div>
    </S.ForbiddenError>
  );

  return (
    <PermissionTest
      requiredPermissions={"views/superadmin"}
      domainId={ROOT_DOMAIN}
      fallback={forbiddenError}
    >
      <S.Wrapper>
        <TabBar>{tabItems}</TabBar>
        <Switch>
          <Route path="/internal/orgs/:orgId" component={OrgDetailView} />
          {routes}
          <Route path="*">
            <Redirect to={tabs[0].route} />
          </Route>
        </Switch>
      </S.Wrapper>
    </PermissionTest>
  );
};
